module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "tni-ctr"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Do You Know:")])]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }, [_vm._v("• What to do if your dog is choking …")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }, [_vm._v("• Which plants in your home could be toxic to your dog …")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }, [_vm._v("• Why providing a doghouse for your pet will help his mental health …")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }, [_vm._v("• What kind and how much exercise will prevent your dog from gaining weight …")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }, [_vm._v("• Which nutrients and supplements can dramatically extend your dog’s life …")]), _vm._v(" "), _c('p', {
    staticClass: "tni1"
  }, [_vm._v("Find Out All the Answers in")]), _vm._v(" "), _c('p', {
    staticClass: "tni2"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Anti-Aging")])]), _vm._v(" "), _c('p', {
    staticClass: "tni3"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("for")])]), _vm._v(" "), _c('p', {
    staticClass: "tni2"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Dogs")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27645da5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm.vue
// module id = 66
// module chunks = 0